import { mutationTypes } from './mutations';
import api from './api'

export const actionTypes = {
	filesLoad: 'filesLoad',
	filesCreate: 'filesCreate',
	filesUpdate: 'filesUpdate',
	filesDestroy: 'filesDestroy',
	filesValidate: 'filesValidate'
};

export default {
	[actionTypes.filesLoad]({ commit }) {
		return api.filesLoad()
			.then(data => commit(mutationTypes.FILES_LOAD, data))		
	},
	[actionTypes.filesCreate]({ commit }, {file, folder}) {
		return api.filesCreate(file, folder)
			.then(({data}) => {
				commit(mutationTypes.FILES_CREATE, data)
				return data
			})
	},
	[actionTypes.filesUpdate]({ commit }, {id, file, folder}) {
		return api.filesUpdate(id, file, folder)
			.then(({data}) => {
				commit(mutationTypes.FILES_UPDATE, data)
				return data
			}) 
	},
	[actionTypes.filesDestroy]({ commit }, file) {
		return api.filesDestroy(file)
			.then(data => commit(mutationTypes.FILES_DESTROY, file))
	},
	[actionTypes.filesValidate]({ state }, file) {
		return new Promise((resolve, reject) => {
			const res = {
				isValid: true,
				filename: file.name,
				filesize: file.size,
				mime: file.type,
				messages: []
			}	
			if (!state.validation.mimes.includes(file.type)) {
				res.isValid = false
				res.messages.push({
					key: 'mimes',
					label: 'This file type is not currently supported'
				})
			}	
			if (file.type == 'application/pdf' && state.validation.size.pdf < file.size) {
				res.isValid = false
				res.messages.push({
					ket: 'size',
					label: 'This PDF is too big for the system to handle right now'
				})
			}
			if (file.type.includes('image')) {
				if (state.validation.size.image < file.size) {
					res.isValid = false
					res.messages.push({
						key: 'size',
						label: 'The size of this image is too big for the system to handle right now'
					})
				}
				let dimensions = null
				let _URL = window.URL || window.webkitURL
				let image = new Image()
				image.onload = function() {
					res.dimensions = {
						width: this.width,
						height: this.height
					}
					if (this.width < state.validation.dimensions.min.width || 
							this.height < state.validation.dimensions.min.height) {
						res.isValid = false
						res.messages.push({
							key: 'dimensions',
							label: 'The dimensions of this image is too small to be used'
						})
					}
					if (this.width > state.validation.dimensions.max.width || 
							this.height > state.validation.dimensions.max.height) {
						res.isValid = false
						res.messages.push({
							key: 'dimensions',
							label: 'The dimensions of this image is too big to be used'
						})
					}
					resolve(res)
				}			
				image.src = _URL.createObjectURL(file)	
			}
			else
				resolve(res)
		})
	}	
};
